import { Routes } from '@angular/router';
import { LocationClosuresComponent } from '@app/features/locations/components/location-closures/location-closures.component';
import { Authority } from '@app/shared/utils/enums';

export const locationClosuresRoutes: Routes = [
    {
        path: 'location-closures',
        children: [
            {
                path: '',
                component: LocationClosuresComponent,
                data: {
                    authorities: [Authority.ADMIN]
                }
            }
        ]
    }
]